import { render } from "./EmailTable.vue?vue&type=template&id=0048e76a"
import script from "./EmailTable.vue?vue&type=script&lang=js"
export * from "./EmailTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__